const BugIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M8 2l1.5 1.5" />
        <path d="M14.5 3.5L16 2" />
        <path d="M9 7.5A3 3 0 0 1 15 7.5" />
        <path d="M6.5 7.5C5 7.5 3 8.5 3 10.5v1c0 1.5 1 2.5 2 3" />
        <path d="M17.5 7.5C19 7.5 21 8.5 21 10.5v1c0 1.5-1 2.5-2 3" />
        <rect x="9" y="7" width="6" height="10" rx="3" />
        <path d="M9 11H6" />
        <path d="M18 11h-3" />
        <path d="M9 15H5" />
        <path d="M19 15h-4" />
        <path d="M9.5 19c.5 1 1.5 2 2.5 2s2-1 2.5-2" />
    </svg>
);

export default BugIcon;
